import { useMemo, useState } from 'react';
import { filterCollectionBySearch } from '~/helpers/utils';
import { ChainSummary } from '~/types/Chain';

export function useChainFilters(chains: ChainSummary[]) {
  const [search, setSearch] = useState<string>('');
  const [hasReviews, setHasReviews] = useState(false);
  const [hasAdvisors, setHasAdvisors] = useState(false);

  const filteredChains = useMemo(() => {
    let results = filterCollectionBySearch(chains, search);

    results = results.filter(c => {
      const stats = c.statistics || {};

      if (hasReviews && !(Number(stats.numberOfReviews) > 0)) return false;
      if (hasAdvisors && !(Number(stats.numberOfAdvisors) > 0)) return false;

      return true;
    });

    return results;
  }, [chains, search, hasReviews, hasAdvisors]);
  
  return {
    search,
    setSearch,
    hasReviews,
    setHasReviews,
    hasAdvisors,
    setHasAdvisors,
    filteredChains,
  }
}